import { useAgentClient } from '@/data/Agents/useAgentClient'
import type { GroupFilter } from '@/modules/Project/Filters/types'
import { useWorkspaceContext } from '@/modules/Workspaces/useWorkspaceContext'
import { computed, type ComputedRef, type MaybeRefOrGetter } from 'vue'

/** Returns a filter that can be used to filter hub entities that have errored. */
export const useHubErrorFilter = (
  fileProjectId: MaybeRefOrGetter<string | undefined>,
): ComputedRef<GroupFilter | undefined> => {
  const { workspaceId } = useWorkspaceContext()
  const { data: fileProject } = useAgentClient({ workspaceId }).fetch(fileProjectId)

  return computed<GroupFilter | undefined>(() => {
    if (!fileProject.value) {
      return
    }

    const filter: GroupFilter = { conjunction: 'or', filters: [] }
    for (const property of fileProject.value.properties) {
      filter.filters.push({
        subject: 'field_status',
        matcher: {
          name: 'property_any_of',
          values: ['error'],
          property_id: property.id,
        },
      })

      filter.filters.push({
        subject: 'select_option_value',
        matcher: {
          name: 'property_any_of',
          values: ['invalid'],
          property_id: property.id,
        },
      })
    }

    return filter
  })
}
